import { PageSectionTheme } from "../PageSection.types";

const theme: PageSectionTheme = {
	margins: {
		xs: "20px",
		sm: "20px",
		md: "20px",
		lg: "40px",
		xl: "60px",
		xxl: "60px",
	},

	maxWidth: "1320px",
};

export default theme;
